import { render, staticRenderFns } from "./orderDetailInfo.vue?vue&type=template&id=1f7820ce"
import script from "./orderDetailInfo.vue?vue&type=script&lang=js"
export * from "./orderDetailInfo.vue?vue&type=script&lang=js"
import style0 from "./orderDetailInfo.vue?vue&type=style&index=0&id=1f7820ce&prod&lang=scss&rel=stylesheet%2Fscss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports